import classNames from 'classnames';
import React from 'react';

const FormSection = ({ onSubmit, renderActions, title, description, children }) => {

  const hasActions = !!renderActions;

  return (
    <div className="w-full my-6">
        <div className='flex flex-col'>
            <h6 className='text-xl font-medium'>{title}</h6>
            <div className='text-grey mt-2'>{description}</div>      
        </div>
        <div className="mt-5 w-full">
            <form
            onSubmit={e => {
                e.preventDefault();
                onSubmit();
            }}
            >
            <div
                className={classNames(
                'py-3 bg-light sm:p-0',
                hasActions
                    ? 'sm:rounded-tl-md sm:rounded-tr-md'
                    : 'sm:rounded-md',
                )}
            >
                <div className="grid grid-cols-2 gap-y-2 gap-x-4">{children}</div>
            </div>

            {hasActions && (
                <div className="grid w-full">
                {renderActions()}
                </div>
            )}
            </form>
        </div>
    </div>
  );
}

export default FormSection;